<template>
  <div id="packages-edit">
      <el-card class="box-card" shadow="never">
        <Row>
          <Col span="4"><div><span style="font-weight: bold;">姓名：</span><span>{{edit.name}}</span></div></Col>
          <Col span="5"><div><span style="font-weight: bold;">出生日期：</span><span>{{edit.birthday}}</span></div></Col>
          <Col span="5"><div><span style="font-weight: bold;">条形码：</span><span>{{edit.barCode}}</span></div></Col>
          <Col span="4"><div><span style="font-weight: bold;">收表人：</span><span>{{edit.operator}}</span></div></Col>
          <Col span="6"><div><span style="font-weight: bold;">收表时间：</span><span>{{edit.createTime}}</span></div></Col>
        </Row>
      </el-card>

      <el-card class="box-card" shadow="never" style="margin-top: 10px;" v-for="(rowData ,index) in edit.logProjects">
        <Row>
          <Col span="24" style="font-size: 20px;font-weight: bold;margin-bottom: 8px;"><span >{{rowData.projectName}}</span></Col>
          <Col span="6" v-for="(child) in rowData.logFieldConfigs"  style="margin-bottom: 5px;">
            <div><span style="font-weight: bold;">{{child.fieldConfigName}}：</span><span>{{child.fieldConfigValue}}</span><span style="margin-left: 5px;" v-if="child.fieldConfigValue&&child.unit">{{child.unit}}</span></div>
          </Col>
        </Row>
      </el-card>
  </div>
</template>
<script>

import {_get} from "@/services/operationRecord/collectionLog.js";
export default {
  name: "CollectionLogEdit",
  data() {
    return {
      edit: {

      },
      init: "",
    };
  },
  mounted() {
    this.init = Object.assign({}, this.edit);
  },
  methods: {
    handleModal(row) {
      _get({collectionLogId: row.collectionLogId}).then(res => {
        this.edit = Object.assign({}, res.data);
        this.$forceUpdate();
      })
    },
  }
};
</script>
<style lang="postcss" scoped>

</style>
